import React from 'react';
import { Link } from 'react-router-dom';
import bgImg from '../../../assets/bg-services.jpg';

const bgImageStyle = {
    backgroundImage: `url(${bgImg})`
}

const JoinClass = () => {
    return (
        <div className='my-5' style={bgImageStyle}>
            <div className='py-5 px-2 bg-success bg-gradient bg-opacity-25 rounded-2 d-flex flex-column justify-content-center align-items-center'>
                <Link to="/allservices"><button className='btn btn-outline-light rounded-pill fw-bold text-black'>Services</button></Link>
                <h3 className='py-4 text-center text-white fw-light'>CHOOSE YOUR SERVICE AND START YOUR TRAINING</h3>
                <Link to="/allservices"><button className='px-4 btn btn-outline-warning rounded-pill fw-bold'>View Services</button></Link>
                <p></p>
            </div>
        </div>
    );
};

export default JoinClass;